/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowSubsystemResult } from './ShadowSubsystemResult';
import {
    ShadowSubsystemResultFromJSON,
    ShadowSubsystemResultFromJSONTyped,
    ShadowSubsystemResultToJSON,
    ShadowSubsystemResultToJSONTyped,
} from './ShadowSubsystemResult';

/**
 * The five backend subsystems as written by the shadow auto-decisioning
 * processor. The FE is responsible for mapping these onto its UI sub-tabs
 * (e.g. background = safety + administrative, admission_package =
 * clinical + medication rows, etc.).
 * 
 * occupancy carries outcome SKIPPED when the facility is configured to
 * skip the occupancy subsystem; the FE hides the Bed Availability card
 * for those decisions.
 * 
 * @export
 * @interface ShadowSubsystemResults
 */
export interface ShadowSubsystemResults {
    /**
     * 
     */
    clinical: ShadowSubsystemResult;
    /**
     * 
     */
    financial: ShadowSubsystemResult;
    /**
     * 
     */
    safety: ShadowSubsystemResult;
    /**
     * 
     */
    administrative: ShadowSubsystemResult;
    /**
     * 
     */
    occupancy: ShadowSubsystemResult;
}

/**
 * Check if a given object implements the ShadowSubsystemResults interface.
 */
export function instanceOfShadowSubsystemResults(value: object): value is ShadowSubsystemResults {
    if (!('clinical' in value) || value['clinical'] === undefined) return false;
    if (!('financial' in value) || value['financial'] === undefined) return false;
    if (!('safety' in value) || value['safety'] === undefined) return false;
    if (!('administrative' in value) || value['administrative'] === undefined) return false;
    if (!('occupancy' in value) || value['occupancy'] === undefined) return false;
    return true;
}

export function ShadowSubsystemResultsFromJSON(json: any): ShadowSubsystemResults {
    return ShadowSubsystemResultsFromJSONTyped(json, false);
}

export function ShadowSubsystemResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemResults {
    if (json == null) {
        return json;
    }
    return {
        
        'clinical': ShadowSubsystemResultFromJSON(json['clinical']),
        'financial': ShadowSubsystemResultFromJSON(json['financial']),
        'safety': ShadowSubsystemResultFromJSON(json['safety']),
        'administrative': ShadowSubsystemResultFromJSON(json['administrative']),
        'occupancy': ShadowSubsystemResultFromJSON(json['occupancy']),
    };
}

export function ShadowSubsystemResultsToJSON(json: any): ShadowSubsystemResults {
    return ShadowSubsystemResultsToJSONTyped(json, false);
}

export function ShadowSubsystemResultsToJSONTyped(value?: ShadowSubsystemResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clinical': ShadowSubsystemResultToJSON(value['clinical']),
        'financial': ShadowSubsystemResultToJSON(value['financial']),
        'safety': ShadowSubsystemResultToJSON(value['safety']),
        'administrative': ShadowSubsystemResultToJSON(value['administrative']),
        'occupancy': ShadowSubsystemResultToJSON(value['occupancy']),
    };
}

